module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sYeMTL/tc-custom/9780802192905.jpg?1708658264634",
      "alt": "This image is the cover for the book Singing at the Gates"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Singing at the Gates\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“This fiery retrospective collection” of poetry by the acclaimed Chicano-American author of "), _c('i', [_vm._v("A Place to Stand")]), _vm._v(" is “warm and furious…righteous and prayerful” ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Award-winning writer Jimmy Santiago Baca is lauded for his talent in weaving personal and political threads to create a pertinent and poignant narrative. He addresses universal issues with passion, grace, and vivid sensory detail."), _c('br'), _c('br'), _c('i', [_vm._v("Singing at the Gates")]), _vm._v(" is a collection of Baca’s work stretching across four decades—poems that revitalize the national dialogue: raging against war and imprisonment, celebrating family and the bonds of friendship, heightening appreciation for and consciousness of the environment. A career-spanning selection, it includes poems drawn from Baca’s first chapbook, letters he wrote from prison to a woman named Mariposa, and recent meditations on the significance of breaking through oppression. "), _c('br'), _c('br'), _c('b', [_vm._v("“A poet whose voice, brutal and tender, is unique in America.”—"), _c('i', [_vm._v("The Nation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jimmy Santiago Baca\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove/Atlantic Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0